import "../../css/widgets/widgets.css";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Row, Col } from 'react-bootstrap';
import React from 'react';

function OutgoingGroupCalls(props) {

    const { t } = useTranslation();

    return (
        <div className={"card card-flush overflow-hidden"} >
            <div className="card-header ">
                <h3 className="card-title align-items-start flex-column text-primary">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("phone-arrow-up-right")} /> {t("outgoingcalls")}</span>

                </h3>
                <div className="card-toolbar">
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                <Row>
                    <Col >
                        <div className="fs-2hx fw-bold text-gray-800">{props.group.outgoingCalls}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("total")}</div>
                    </Col>
                    <Col >
                        <div className="fs-2hx fw-bold text-success">{props.group.outgoingCallsMissed}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("attended")}</div>
                    </Col>
                    <Col >
                        <div className="fs-2hx fw-bold text-danger">{props.group.outgoingCallsAnsweredCalls}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("missed")}</div>
                    </Col>
                    <Col></Col>
                    <Col></Col>
                </Row>
            </div>
        </div>

    )
}
export default OutgoingGroupCalls;